import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  snapBailiffJobById,
  unSnapBailiffJobById,
} from "store/bailiff/bailiff/job/bailiff_job.action";
import { bailiffJobSelectedSelector } from "store/bailiff/bailiff/job/bailiff_job.selector";
import { snapOrderBailiffById } from "store/bailiff/payment/order/order_bailiff.action";
// import { orderBailiffOpenPaymentSelector } from "store/bailiff/payment/order/order_bailiff.selector";
//
//component
//redux
//selector
//actions
export const TriggerJobPayment = () => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // const open = useSelector(orderBailiffOpenPaymentSelector);
  const selected = useSelector(bailiffJobSelectedSelector);
  const jobId = selected?.id;
  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    if (jobId) {
      // snap thằng jobId.
      dispatch(snapBailiffJobById({ id: jobId }));
    }

    return () => dispatch(unSnapBailiffJobById());
  }, [jobId, dispatch]);

  // snap pament.
  useEffect(() => {
    if (jobId) {
      // snap thằng jobId.
      dispatch(snapOrderBailiffById({ jobId }));
    }

    return () => dispatch(unSnapBailiffJobById());
  }, [jobId, dispatch]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerJobPayment;
